import { createSelector } from '@ngrx/store';
import { IAppState } from '../state/app-config.state';

const _appState = (state: IAppState) => state;

export const selectAppState = createSelector (
  _appState,
  (appState: IAppState) => appState
);
